import React from "react";
import styles from "../../../management/db-list/detail/DatabaseDetail.module.scss";
import { SonicTeamData } from "../../../../common/classes/SonicTeam";
import { SonicUserData } from "../../../../common/classes/SonicUser";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import Status from "../../../../common/management/detail/Status";
import NotificationModal from "../../../../common/settings-modal/NotificationModal";
import { checkForJikeiRoles } from "../../../../utils/GeneralUtils";
import {
  RequestState,
  genNotificationColor,
  genNotificationMessage,
} from "../../../../utils/RequestState";
import SelenaA from "../../../../assets/img/service/selena-a.webp";
import SonicLink from "../../../../common/routing/SonicLink";

type Props = {
  team: SonicTeamData;
  owner: SonicUserData;
  isLoading: boolean;
  requestState: RequestState;

  selectStatus?: string;
  setSelectStatus: (value: string, name: string) => void;
  handleUpdate: () => void;

  showStatusMenu: boolean;
  handleStatusMenu: () => void;
};
const JikeiTeamDetail: React.FC<Props> = ({
  team,
  owner,
  isLoading,
  requestState,
  selectStatus,
  setSelectStatus,
  handleUpdate,
  showStatusMenu,
  handleStatusMenu,
}) => {
  return (
    <div className={styles["f-databaseDetail"]}>
      {isLoading || !team || !owner ? (
        <LoadingSpinner space={1} admin_page={true} />
      ) : (
        <>
          <h1 className={styles["f-databaseDetail__title"]}>チーム詳細</h1>
          <div className={styles["f-databaseDetail__inner"]}>
            <div className={styles["f-databaseDetail__head"]}>
              <Status
                isVisibilityStatus={true}
                status={team?.status}
                selectStatus={selectStatus}
                showStatusMenu={showStatusMenu}
                handleStatusMenu={handleStatusMenu}
                setSelectStatus={setSelectStatus}
              />
              <div className={styles["f-databaseDetail__user"]}>
                <div className={styles["f-databaseDetail__user-head"]}>
                  <h2 className={styles["f-databaseDetail__user-head__title"]}>
                    ユーザー情報
                  </h2>
                  <SonicLink
                    to={
                      checkForJikeiRoles(owner?.roles, true)
                        ? `/jikei/manager/${owner?.id}`
                        : `/jikei/student/${owner?.id}`
                    }
                  >
                    ユーザー詳細
                  </SonicLink>
                </div>
                <div className={styles["f-databaseDetail__user-info"]}>
                  <div>
                    <p>ユーザー名</p>
                    <span>{owner?.meta?.full_name}</span>
                  </div>
                  <div>
                    <p>メールアドレス</p>
                    <span>{owner?.meta?.email}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                チーム/団体
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.name}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                チーム/団体(ふりがな)
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.kana}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                チーム紹介
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.description}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                ゲームタイトル
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.game && team.game.length > 0
                  ? team.game.map((el) => el.name).join(`\n`)
                  : "未選択"}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                X (旧Twitter)
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.sns?.twitter?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Instagram
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.sns?.instagram?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Facebook
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.sns?.facebook?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Youtube
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.sns?.youtube?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Twitch
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {team?.sns?.twitch?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__btn"]}>
              <button
                className={styles["f-databaseDetail__btn-save"]}
                onClick={() => handleUpdate()}
              >
                保存
              </button>
            </div>
          </div>
        </>
      )}
      {requestState !== RequestState.Waiting ? (
        <NotificationModal
          color={genNotificationColor(requestState)}
          message={genNotificationMessage(requestState)}
          img_src={requestState === RequestState.Success ? SelenaA : undefined}
        />
      ) : null}
    </div>
  );
};

export default JikeiTeamDetail;
